import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "flex"
};
const _hoisted_2 = {
  class: "w-full"
};
const _hoisted_3 = {
  class: "flex justify-between space-x-2 tw py-2"
};
const _hoisted_4 = {
  class: "w-1/2"
};
const _hoisted_5 = {
  class: "w-1/2 flex gap-2"
};
const _hoisted_6 = {
  class: "w-1/2 pt-8"
};
const _hoisted_7 = {
  key: 0,
  class: "split-half"
};
const _hoisted_8 = {
  class: "flex justify-between space-x-2 tw py-2"
};
const _hoisted_9 = {
  class: "w-1/2",
  "data-cy": "ff-amount-div",
  "data-replay-unmask": ""
};
const _hoisted_10 = {
  key: 2,
  class: "tw py-2"
};
const _hoisted_11 = {
  key: 3,
  "data-cy": "ff-description-div",
  class: "w-full mt-4"
};
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTextarea from '@/components/LlTextarea.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlSelect from '@/components/LlSelect.vue';
import SelectUser from '@/components/SelectUser.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import CodePicker from '@/components/CodePicker.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
import DescriptionPreviewModal from './DescriptionPreviewModal.vue';
import LlResizableTextarea from '@/components/LlResizableTextarea.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useChargesStore } from '@/services/UserService/useChargesStore';
import EventTracker from '@/services/eventTracker';
import { TrackingCategory, TrackingAction } from '@/constants/trackingConstants';
import { onMounted, reactive, watch } from 'vue';
import { storeToRefs } from 'pinia';
export default {
  __name: 'FixedFeeLineItem',
  props: {
    isNewFixedFee: {
      type: Boolean,
      required: false
    },
    tracking: {
      type: Object,
      required: false
    }
  },
  emits: ['confirm', 'cancel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const invoiceState = useInvoiceState();
    const invoiceEditorStore = useInvoiceEditorStore();
    const companyStore = useCompanyStore();
    const {
      loadStandardCharges
    } = useChargesStore();

    // Track Fee Viewed for draft invoice entry point (only when editing existing, not creating new)
    if (props.tracking && !props.isNewFixedFee) {
      EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEE_TAB, TrackingAction.VIEWED, {
        entryPoint: 'draft_invoice',
        tab: 'detail'
      });
    }
    const {
      permissions,
      features
    } = storeToRefs(useMeStore());
    const {
      selectedLineItem
    } = invoiceEditorStore;
    const {
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const {
      companySettings
    } = storeToRefs(companyStore);
    const {
      standardCharges,
      standardChargesWithDisplay
    } = storeToRefs(useChargesStore());
    const {
      getIsLocked
    } = useInvoiceState();
    const customFlagLabel = companySettings.value.labels?.customFlag || false;
    const emit = __emit;
    const fixedFeeModalState = reactive({
      selectedFixedFeeTemplate: null,
      loading: false,
      form: {
        id: '',
        description: '',
        date: '',
        account: {
          id: '',
          name: ''
        },
        amount: '',
        codes: {
          activity: {
            id: null
          },
          task: {
            id: null
          }
        },
        charges: [{
          codes: {
            activity: {
              id: null
            },
            task: {
              id: null
            }
          },
          amount: '',
          account: {
            id: '',
            name: ''
          },
          customFlag: false,
          description: ''
        }]
      }
    });
    onMounted(async () => {
      fixedFeeModalState.loading = true;
      await loadStandardCharges();
      fixedFeeModalState.form = JSON.parse(JSON.stringify(selectedLineItem));
      fixedFeeModalState.loading = false;
    });
    const saveNewFixedFee = () => {
      fixedFeeModalState.form.charges.forEach(charge => {
        charge.amount = fixedFeeModalState.form.amount;
        charge.description = fixedFeeModalState.form.description;
      });
      invoiceEditorStore.saveNewFixedFee(fixedFeeModalState.form);

      // Track Fixed Fee Created event from draft invoice
      if (props.tracking) {
        EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEE, TrackingAction.CREATED, {
          entryPoint: 'draft_invoice',
          isTemplate: !!fixedFeeModalState.form.template
        });
      }
    };
    const confirm = () => {
      fixedFeeModalState.form.amount = parseFloat(fixedFeeModalState.form.amount);
      fixedFeeModalState.form.charges.forEach(charge => {
        charge.amount = fixedFeeModalState.form.amount;
        charge.date = fixedFeeModalState.form.date;
        charge.customFlag = fixedFeeModalState.form.customFlag;
      });
      fixedFeeModalState.form.description = fixedFeeModalState.form.descriptionPreview;
      invoiceState.updateLineItem(fixedFeeModalState.form);
      emit('cancel');
    };
    const handleAccountChange = () => {
      fixedFeeModalState.form.charges.forEach(ch => ch.account = fixedFeeModalState.form.account);
    };
    const handleDateChange = () => {
      fixedFeeModalState.form.charges.forEach(c => c.date = fixedFeeModalState.form.date);
      // dateChanged will trigger a re-sort when we save
      fixedFeeModalState.form.dateChanged = !invoiceEditorStore.sameDate(fixedFeeModalState.form.date, selectedLineItem.date);
    };
    const selectTemplate = () => {
      if (fixedFeeModalState.form.template) {
        const {
          date
        } = fixedFeeModalState.form;
        fixedFeeModalState.form = {
          ...fixedFeeModalState.form,
          ...fixedFeeModalState.form.template,
          date
        };
      }
    };
    const handleCodeChange = codes => {
      fixedFeeModalState.form.codes = codes;
      fixedFeeModalState.form.charges.forEach(ch => ch.codes = codes);
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, {
        loading: fixedFeeModalState.loading
      }, {
        prepend: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "headline"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.isNewFixedFee ? 'Add New Fixed Fee' : 'Edit Line Item Fixed Fee'), 1)]),
          _: 1
        })]),
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('cancel'))
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [!__props.isNewFixedFee && !fixedFeeModalState.loading ? (_openBlock(), _createBlock(DescriptionPreviewModal, {
            key: 0,
            "line-item": fixedFeeModalState.form,
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["line-item", "disabled"])) : _createCommentVNode("", true), __props.isNewFixedFee ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(LlSelect, {
            modelValue: fixedFeeModalState.form.template,
            "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => fixedFeeModalState.form.template = $event), selectTemplate],
            items: _unref(standardChargesWithDisplay),
            "item-title": "displayText",
            "item-value": "id",
            "return-object": "",
            placeholder: "Select Fixed Fee Template",
            label: "Fixed Fee Template",
            isAutocomplete: "",
            "hide-details": true,
            labelClass: "py-2",
            loading: true
          }, null, 8, ["modelValue", "items"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(SelectUser, {
            modelValue: fixedFeeModalState.form.account,
            "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => fixedFeeModalState.form.account = $event), handleAccountChange],
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit,
            "use-matter-filtering": true,
            "matter-id": _unref(invoiceState).getCurrentMatterId()
          }, null, 8, ["modelValue", "disabled", "matter-id"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
            class: _normalizeClass(_unref(customFlagLabel) ? 'w-1/2' : 'w-full')
          }, [_createVNode(LlDatePicker, {
            modelValue: fixedFeeModalState.form.date,
            "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => fixedFeeModalState.form.date = $event), _cache[4] || (_cache[4] = $event => handleDateChange())],
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["modelValue", "disabled"])], 2), _createElementVNode("div", _hoisted_6, [_unref(customFlagLabel) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(LlCheckbox, {
            label: _unref(customFlagLabel),
            modelValue: fixedFeeModalState.form.customFlag,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => fixedFeeModalState.form.customFlag = $event),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["label", "modelValue", "disabled"])])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(LlTextField, {
            prefix: '$',
            type: "number",
            label: "Amount",
            modelValue: fixedFeeModalState.form.amount,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => fixedFeeModalState.form.amount = $event),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["modelValue", "disabled"])])]), _unref(invoiceState).ledes ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(CodePicker, {
            form: fixedFeeModalState.form,
            onCodeChange: handleCodeChange
          }, null, 8, ["form"])])) : _createCommentVNode("", true), __props.isNewFixedFee ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(LlResizableTextarea, {
            modelValue: fixedFeeModalState.form.description,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => fixedFeeModalState.form.description = $event),
            label: "Description"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [_createVNode(_component_v_list_item, {
            class: "w-100"
          }, _createSlots({
            prepend: _withCtx(() => [_createVNode(LlSecondaryButton, {
              class: "mr-2",
              onBtnClick: _cache[8] || (_cache[8] = $event => _ctx.$emit('cancel'))
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(getIsLocked) || _unref(onlyViewInvoice) ? 'Close' : 'Cancel'), 1)]),
              _: 1
            })]),
            _: 2
          }, [__props.isNewFixedFee ? {
            name: "append",
            fn: _withCtx(() => [_createVNode(LlSecondaryButton, {
              color: "primary",
              variant: "flat",
              onBtnClick: _cache[9] || (_cache[9] = $event => saveNewFixedFee()),
              "data-cy": "create-fixed-fee"
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" Create Fixed Fee ", -1)]))]),
              _: 1
            })]),
            key: "0"
          } : {
            name: "append",
            fn: _withCtx(() => [!(_unref(onlyViewInvoice) || _unref(getIsLocked)) ? (_openBlock(), _createBlock(LlSecondaryButton, {
              key: 0,
              color: "primary",
              variant: "flat",
              onBtnClick: _cache[10] || (_cache[10] = $event => confirm()),
              "data-cy": "save-fixed-fee"
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode(" Apply ", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)]),
            key: "1"
          }]), 1024)]),
          _: 1
        })]),
        _: 1
      }, 8, ["loading"]);
    };
  }
};